<app-rad-base-modal
    #radBaseModal
    class="app-agreement-modal"
    [identifier]="modalType"
    [closable]="true"
    [showCloseButton]="true"
    [showConfirmButton]="showConfirmButton"
    [closeButtonText]="modalCloseButtonText"
    [confirmButtonText]="modalConfirmButtonText">
    
    <section>
      <div class="eula-illumina-title-container">
        <div class="illumina-title" role="img" aria-label="Illumina Logo"></div>
      </div>
      
      <div class="app-name">{{application.Name}}</div>
      <div class="title-other-info">App Version: {{application.VersionNumber}}</div>
    </section>
    <section class="content-container">
      <div [innerHTML]="modalContent"></div>
      <div class="modal-dialog__footer"></div>
    </section>
    
  </app-rad-base-modal>
